import React from 'react'
import type { BaseRange } from 'slate'

import type { UserMention } from '../../types'
import { MentionsContext } from './context'

export const MENTIONS_QUERY_THRESHOLD = 3

function getDefaultFilter(usersInThread: UserMention[]) {
  return (input: string) =>
    Promise.resolve(
      usersInThread.filter(user => user.displayName.toLowerCase().startsWith(input.toLowerCase()))
    )
}

export function MentionsContextProvider({
  children,
  usersInThread,
  getMentionSuggestions,
}: {
  children: React.ReactNode
  usersInThread: UserMention[]
  getMentionSuggestions?: (userInput: string) => Promise<UserMention[]>
}): React.ReactElement {
  const [filter, setFilter] = React.useState('')
  const [userList, setUserList] = React.useState(usersInThread)
  const [menuIndex, setMenuIndex] = React.useState(0)
  const [rangeToReplace, setRangeToReplace] = React.useState<BaseRange | null>(null)

  const closeMentionsMenu = () => {
    setRangeToReplace(null)
    setMenuIndex(-1)
    setFilter('')
  }

  const mentionsContext = React.useMemo(
    () => ({
      filter,
      setFilter,
      usersInThread,
      userList,
      setUserList,
      menuIndex,
      setMenuIndex,
      rangeToReplace,
      setRangeToReplace,
      closeMentionsMenu,
      getMentionSuggestions: getMentionSuggestions ?? getDefaultFilter(usersInThread),
    }),
    [filter, usersInThread, userList, menuIndex, rangeToReplace, getMentionSuggestions]
  )

  return <MentionsContext.Provider value={mentionsContext}>{children}</MentionsContext.Provider>
}
